@if (resume?.subData?.content) {
  <img class="portrait-tiny" [src]="resume?.subData?.content?.portraitImageUrl" />
  {{ resume?.subData?.content?.firstName }}
}
